import React, { useState } from 'react'

import dynamic from 'next/dynamic'

import { Image } from './styles'

import { Row } from 'components/v2/Grid'
import { LinkComponent } from 'components/v2/Link'
import { Text } from 'components/v2/Text'

import { testimonialsEnterprisePost } from 'utils/constants'

const LazyImage = dynamic(() => import('components/shared/LazyImage'), {
	ssr: false
})

const Testimonials = () => {
	const [count, setCount] = useState(0)

	const selectSlide = (number) => {
		setCount(number)
	}

	return (
		<section id='on-media'>
			<Row className='bg-[#F9FAFD] py-16'>
				<Row className='mx-auto max-w-[1200px] flex-col flex-wrap px-3'>
					<Row className='flex-wrap items-center justify-between pb-[61px]'>
						{testimonialsEnterprisePost.map((post, index) => (
							<div
								key={index}
								onClick={() => selectSlide(index)}
								className='flex min-w-0 cursor-pointer flex-col'
							>
								<Image>
									<LazyImage
										className={
											count === index ? 'lazy-img active-logo' : 'lazy-img'
										}
										src={{
											webp: post.image_webp,
											png: post.image
										}}
										alt={`Na mídia ${index}`}
									/>
								</Image>
							</div>
						))}
					</Row>
					<Row>
						{testimonialsEnterprisePost.map((post, index) => (
							<Row
								key={index}
								className='min-w-full flex-wrap justify-between'
								style={{ display: count === index ? 'flex' : 'none' }}
							>
								<Text
									variant='regular'
									className='text-base leading-[150%] text-[#293450]'
								>
									{post.text}{' '}
									<LinkComponent
										className='text-orange-600 ml-[5px] inline-flex no-underline'
										href={post.href}
										label='Ler matéria'
										target='__blank'
										id='media-read-article'
										icon
									/>
								</Text>
							</Row>
						))}
					</Row>
				</Row>
			</Row>
		</section>
	)
}

export default Testimonials
